<div fxLayout="column" fxLayoutGap="20px">
  <div fxLayoutAlign.gt-xs="space-between center">
    <h1>Lista de Presença do Concurso:</h1>
  </div>
  <h2>{{concursoTitulo}}</h2>
  
  <div fxLayoutAlign="center center" *ngIf="provaAndamento" class="exam-progress">
    <h3>{{provaAndamento}}</h3>
  </div>

  <app-search-input #searchInput></app-search-input>

  <div>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="nomeCandidato">
        <th mat-header-cell *matHeaderCellDef>Nome</th>
        <td mat-cell *matCellDef="let row">{{ row.nomeSocial || row.nomeCandidato }}</td>
      </ng-container>
      <ng-container matColumnDef="cpf">
        <th mat-header-cell *matHeaderCellDef>CPF</th>
        <td mat-cell *matCellDef="let row">{{ row.cpf }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">{{ row.status }}</td>
      </ng-container>
      <ng-container matColumnDef="classificacao">
        <th mat-header-cell *matHeaderCellDef>Classificação</th>
        <td mat-cell *matCellDef="let row">{{ row.classificacao }}</td>
      </ng-container>
      <ng-container matColumnDef="motivoClassificacao">
        <th mat-header-cell *matHeaderCellDef>Motivo</th>
        <td mat-cell *matCellDef="let row">{{ row.motivoClassificacao || '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="presente">
        <th mat-header-cell *matHeaderCellDef>Presença</th>
        <td mat-cell *matCellDef="let row">
          <mat-select 
            [(value)]="row.presente" 
            [disabled]="isClassificacaoFinalizada(row)"
            placeholder="Selecione">
            <mat-option [value]="true">Presente</mat-option>
            <mat-option [value]="false">Ausente</mat-option>
          </mat-select>
        </td>
      </ng-container>
      <ng-container matColumnDef="dataRegistro">
        <th mat-header-cell *matHeaderCellDef>Data Registro</th>
        <td mat-cell *matCellDef="let row">{{ row.dataRegistro | date:'dd/MM/yyyy HH:mm' }}</td>
      </ng-container>
      <ng-container matColumnDef="usuarioRegistro">
        <th mat-header-cell *matHeaderCellDef>Usuário</th>
        <td mat-cell *matCellDef="let row">{{ row.usuarioRegistro || '-' }}</td>
      </ng-container>
      <ng-container matColumnDef="salvar">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row">
          <button 
            mat-icon-button 
            color="primary" 
            title="Salvar" 
            (click)="salvar(row)"
            [disabled]="isClassificacaoFinalizada(row) || row.presente === null || row.presente === undefined">
            <mat-icon>save</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="colunasGrid.length">
          <app-table-no-data [searchValue]="searchInput?.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator [length]="totalElements"></app-default-paginator>
  </div>
</div>